import { useState, useEffect } from 'react';

export const useInventorySearch = (initialInventory = []) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredInventory, setFilteredInventory] = useState(initialInventory);

    useEffect(() => {
        const lower = searchTerm.toLowerCase();
        setFilteredInventory(
            initialInventory.filter((item) =>
                (item.item?.toLowerCase().includes(lower)) ||
                (item.typeDescription?.toLowerCase().includes(lower)) ||
                (item.type?.toLowerCase().includes(lower)) ||
                (item.model?.toLowerCase().includes(lower)) ||
                (item.location?.toLowerCase().includes(lower)) ||
                (item.tag?.toString().includes(searchTerm))
            )
        );
    }, [searchTerm, initialInventory]);

  const handleSearch = (term) => {
    setSearchTerm(term);
  };

  return {
    filteredInventory,
    handleSearch
  };
};